import React, { useState } from "react";
import { SearchButton, SearchPlateWrapper } from "./SearchPlateStyles";
import PlateField, {
  ERROR_TYPE,
} from "../../../Fleets/components/PlateField/PlateField";
import { toast } from "react-toastify";

interface Props {
  setActivePlate: (plate: string) => void;
}

const SearchPlate: React.FC<Props> = ({ setActivePlate }: Props) => {
  const [plate, setPlate] = useState<string>("");

  const handleClick = () => {
    if (plate.length < 7) {
      toast.error("Preencha uma placa válida!");
      return;
    }

    setActivePlate(plate);
    setPlate("");
  };

  return (
    <SearchPlateWrapper>
      <PlateField
        errorType={ERROR_TYPE.COLOR}
        fullWidth
        hideLabel
        value={plate}
        onChange={setPlate}
      />
      <SearchButton onClick={handleClick}>Pesquisar</SearchButton>
    </SearchPlateWrapper>
  );
};

export default SearchPlate;
